import {IconName} from '@dv5/components'
import {useCallback, useEffect, useState} from 'react'

export type FullscreenTab = 'edit' | 'preview'

export const getFocusIcon = (isFullscreen: boolean): IconName =>
    isFullscreen ? IconName.Collapse : IconName.Expand

export const getFocusButtonTitle = (isFullscreen: boolean): string =>
    isFullscreen ? 'Exit full screen' : 'Full screen'

export const useFullscreenEditor = () => {
    const [isFullscreen, setIsFullscreen] = useState(false)
    const [activeTab, setActiveTab] = useState<FullscreenTab>('edit')

    const toggleFullscreen = useCallback(() => {
        setActiveTab('edit')
        setIsFullscreen(true)
    }, [])

    const exitFullscreen = useCallback(() => {
        setActiveTab('edit')
        setIsFullscreen(false)
    }, [])

    useEffect(() => {
        if (!isFullscreen) {
            return
        }
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                exitFullscreen()
            }
        }
        document.addEventListener('keydown', handleKeyDown)
        const previousOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        return () => {
            document.removeEventListener('keydown', handleKeyDown)
            document.body.style.overflow = previousOverflow
        }
    }, [isFullscreen, exitFullscreen])

    return {
        isFullscreen,
        activeTab,
        setActiveTab,
        toggleFullscreen,
        exitFullscreen,
    }
}